import { Drawer, Grid2, FormControlLabel, Checkbox } from "@mui/material";
import { useState, useEffect } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { ICentreContactManage } from "../../../_common/models/centreContact/centreContactManage.model";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";
import { StandardButton } from "../../../_components/button/primary.button";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { centreContactService } from "../../../_services/centreContact.service";


export const CentreContactsManageDrawer = (params: { isOpen?: boolean, centreId: string,  onSave(): void, onClose(): void }) => {
    const { id } = useParams<{ id: string }>();

    const resetData = (): ICentreContactManage => ({
        id: id ? Number(id) : 0,
        centreContactTypeId: 0,
        fName: '',
        lName: '',
        phone: '',
        fax: '',
        email: '',
        centreId: Number(params.centreId),
        mobile: '',
        notify: false,
        encrypt: false,
        isActive: true
    });

    const [data, setData] = useState<ICentreContactManage>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (id != null)
            fetchData();
        else
            setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!id) return;

        setIsLoading(true);
        return centreContactService
            .get(id)
            .then(
                (json: ICentreContactManage) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return centreContactService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!id) return;
        setIsLoading(true);
        return centreContactService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    function handleCheckboxChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.checked } });
    };

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update Centre Contact" : "Create Centre Contact"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="centreId"
                            label="Centre"
                            required
                            disabled={!!params.centreId }
                            value={data.centreId}
                            onChange={handleChange} dataType={DataTypeEnum.Centres} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="centreContactTypeId"
                            label="Contact Type"
                            required
                            value={data.centreContactTypeId}
                            onChange={handleChange} dataType={DataTypeEnum.CentreContactTypes} />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="fName"
                            name="fName"
                            label="First Name"
                            fullWidth
                            value={data.fName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="lName"
                            name="lName"
                            label="Last Name"
                            fullWidth
                            value={data.lName}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="phone"
                            name="phone"
                            label="Phone Number"
                            fullWidth
                            required
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.phone}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="mobile"
                            name="mobile"
                            label="Mobile Number"
                            fullWidth
                            value={data.mobile}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="fax"
                            name="fax"
                            label="Fax"
                            fullWidth
                            value={data.fax}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="email"
                            name="email"
                            label="Email"
                            fullWidth
                            value={data.email}
                            onChange={handleChange}
                        />
                    </Grid2>
                    {/*<Grid2 size={{ xs: 6 }}>*/}
                    {/*    <FormControlLabel checked={!!data.notify} name="notify"*/}
                    {/*        control={<Checkbox onChange={handleCheckboxChange} color={"primary"} />}*/}
                    {/*        label="Notify"*/}
                    {/*    />*/}
                    {/*</Grid2>*/}
                    {/*<Grid2 size={{ xs: 6 }}>*/}
                    {/*    <FormControlLabel checked={!!data.encrypt} name="encrypt"*/}
                    {/*        control={<Checkbox onChange={handleCheckboxChange} color={"primary"} />}*/}
                    {/*        label="Encrypt"*/}
                    {/*    />*/}
                    {/*</Grid2>*/}

                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: !data.id ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!id && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={disable}>
                                        Disable
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};